import React from "react";
import { Stack, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import LoopIcon from "@mui/icons-material/Loop";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";

const ChatMessageDecrypting = ({ isMine = false }) => {
  const classes = useStyles({ isMine });
  const { t: getLabel } = useTranslation(LangConstant.NS_HOME_CONVERSATION);

  return (
    <Stack direction="row" alignItems="center" className={clsx(classes.decryptingBox)}>
      <Box className={clsx(classes.iconLoad, "rotating-icon")}>
        <LoopIcon />
      </Box>
      <Typography className={clsx(classes.decrypting)}>{getLabel("TXT_DECRYPTING")}</Typography>
    </Stack>
  );
};

export default ChatMessageDecrypting;

const useStyles = makeStyles({
  decryptingBox: {
    padding: "12px 16px",
    display: "flex",
  },
  iconLoad: {
    color: props => (props.isMine ? "#FFFFFF" : "#008FE8"), // Thay đổi màu dựa trên isMine
    fontSize: 24,
    animation: "$rotateReverse 3s linear infinite",
  },
  "@keyframes rotateReverse": {
    from: {
      transform: "rotate(0deg)",
    },
    to: {
      transform: "rotate(-360deg)", // Xoay ngược chiều kim đồng hồ
    },
  },
  decrypting: {
    paddingLeft: "8px",
    fontSize: 14,
    color: props => (props.isMine ? "#FFFFFF" : "#008FE8"), // Thay đổi màu dựa trên isMine
    fontWeight: 500,
    lineHeight: "20px",
  },
});
